import { AbpHttpInterceptor, RefreshTokenService, AbpHttpConfigurationService } from "abp-ng2-module";
import { HTTP_INTERCEPTORS, HttpInterceptor } from "@angular/common/http";
import { Injector, NgModule } from "@angular/core";
import * as ApiServiceProxies from "./service-proxies";
import { NEW_SERVICE_PROXIES } from "./service-proxies.providers";
import { ZeroRefreshTokenService } from "@account/auth/zero-refresh-token.service";
import { ZeroTemplateHttpConfigurationService } from "./zero-template-http-configuration.service";
import { LocalizePipe } from "@shared/common/pipes/localize.pipe";
import { RootService } from "@root/root.service";
import { AngularZoneHttpInterceptor } from "./angular-zone-http.interceptor";
import { GeocodingApiErrorInterceptor } from "./geocoding-api-error.interceptor";
import { ExpiredTokenRefreshInterceptor } from "@account/auth/expired-token-refresh.interceptor";

/** `AbpHttpInterceptor` from abp-ng2-module has no Ivy `ɵprov`; Angular 17+ rejects `useClass` (NG0204). */
export function createAbpHttpInterceptor(configuration: AbpHttpConfigurationService, injector: Injector): HttpInterceptor {
    return new AbpHttpInterceptor(configuration, injector);
}

@NgModule({
    providers: [
        LocalizePipe,
        RootService,
        ApiServiceProxies.UserOutlookCalendarEventServiceServiceProxy,
        ApiServiceProxies.AppAndWebsiteServiceProxy,
        ApiServiceProxies.ServiceCalendarServiceProxy,
        ApiServiceProxies.TimesheetServiceProxy,
        ApiServiceProxies.ReportServiceProxy,
        ApiServiceProxies.LocationTrackingServiceProxy,
        ApiServiceProxies.BlobHelperServiceProxy,
        ApiServiceProxies.TimeAndAttendanceServiceProxy,
        ApiServiceProxies.TimeAndAttendanceReportServiceProxy,
        ApiServiceProxies.TimeAndAttendanceDataSyncServiceProxy,
        ApiServiceProxies.ProductivityBarServiceProxy,
        ApiServiceProxies.ManualTimeServiceProxy,
        ApiServiceProxies.ActivityServiceProxy,
        ApiServiceProxies.ApplicationCategoryServiceProxy,
        ApiServiceProxies.AddAwayTimeServiceProxy,
        ApiServiceProxies.OnBoardingServiceProxy,
        ApiServiceProxies.TenantProductServiceProxy,
        ApiServiceProxies.CompanyProfileServiceProxy,
        ApiServiceProxies.ClientServiceProxy,
        ApiServiceProxies.ProjectServiceProxy,
        ApiServiceProxies.AuditLogServiceProxy,
        ApiServiceProxies.AttendanceReportDistributionServiceProxy,
        ApiServiceProxies.ProjectTaskServiceProxy,
        ApiServiceProxies.CachingServiceProxy,
        ApiServiceProxies.ChatServiceProxy,
        ApiServiceProxies.CommonLookupServiceProxy,
        ApiServiceProxies.EditionServiceProxy,
        ApiServiceProxies.FriendshipServiceProxy,
        ApiServiceProxies.HostSettingsServiceProxy,
        ApiServiceProxies.InstallServiceProxy,
        ApiServiceProxies.LanguageServiceProxy,
        ApiServiceProxies.NotificationServiceProxy,
        ApiServiceProxies.OrganizationUnitServiceProxy,
        ApiServiceProxies.PermissionServiceProxy,
        ApiServiceProxies.ProfileServiceProxy,
        ApiServiceProxies.RoleServiceProxy,
        ApiServiceProxies.SessionServiceProxy,
        ApiServiceProxies.TenantServiceProxy,
        ApiServiceProxies.TenantDashboardServiceProxy,
        ApiServiceProxies.TenantSettingsServiceProxy,
        ApiServiceProxies.TimingServiceProxy,
        ApiServiceProxies.UserServiceProxy,
        ApiServiceProxies.MemberAllocationServiceProxy,
        ApiServiceProxies.UniversalSearchServiceProxy,
        ApiServiceProxies.UserLinkServiceProxy,
        ApiServiceProxies.UserLoginServiceProxy,
        ApiServiceProxies.WebLogServiceProxy,
        ApiServiceProxies.AccountServiceProxy,
        ApiServiceProxies.TokenAuthServiceProxy,
        ApiServiceProxies.TenantRegistrationServiceProxy,
        ApiServiceProxies.HostDashboardServiceProxy,
        ApiServiceProxies.PaymentServiceProxy,
        ApiServiceProxies.DemoUiComponentsServiceProxy,
        ApiServiceProxies.InvoiceServiceProxy,
        ApiServiceProxies.AllDashboardServiceProxy,
        ApiServiceProxies.SubscriptionServiceProxy,
        ApiServiceProxies.InstallServiceProxy,
        ApiServiceProxies.UiCustomizationSettingsServiceProxy,
        ApiServiceProxies.PayPalPaymentServiceProxy,
        ApiServiceProxies.StripePaymentServiceProxy,
        ApiServiceProxies.DashboardCustomizationServiceProxy,
        ApiServiceProxies.WebhookEventServiceProxy,
        ApiServiceProxies.WebhookSubscriptionServiceProxy,
        ApiServiceProxies.WebhookSendAttemptServiceProxy,
        ApiServiceProxies.UserDelegationServiceProxy,
        ApiServiceProxies.DynamicPropertyServiceProxy,
        ApiServiceProxies.DynamicEntityPropertyDefinitionServiceProxy,
        ApiServiceProxies.DynamicEntityPropertyServiceProxy,
        ApiServiceProxies.DynamicPropertyValueServiceProxy,
        ApiServiceProxies.DynamicEntityPropertyValueServiceProxy,
        ApiServiceProxies.TwitterServiceProxy,
        ApiServiceProxies.OutlookCalendarServiceProxy,
        ApiServiceProxies.IntegrationServiceProxy,
        ApiServiceProxies.KekaManagerApprovalServiceProxy,
        ApiServiceProxies.IdentityProviderServiceProxy,
        ApiServiceProxies.AgentHelperServiceProxy,
        ApiServiceProxies.CommonCacheServiceProxy,
        ApiServiceProxies.TimesheetReStructuringServiceProxy,
        ApiServiceProxies.CountryStateCityAppserviceServiceProxy,
        ApiServiceProxies.UserUtilizationDashboardServiceProxy,

        // useExisting: the interceptors and route guard share one instance, so concurrent refreshes become one call
        { provide: RefreshTokenService, useExisting: ZeroRefreshTokenService },
        { provide: AbpHttpConfigurationService, useClass: ZeroTemplateHttpConfigurationService },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AngularZoneHttpInterceptor,
            multi: true,
        },
        {
            // Must run before AbpHttpInterceptor, which adds the (renewed) Authorization header
            provide: HTTP_INTERCEPTORS,
            useClass: ExpiredTokenRefreshInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useFactory: createAbpHttpInterceptor,
            deps: [AbpHttpConfigurationService, Injector],
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: GeocodingApiErrorInterceptor,
            multi: true,
        },
        // Services generated after service-proxies.ts was frozen (see nswag/split-service-proxies.js)
        ...NEW_SERVICE_PROXIES,
    ],
})
export class ServiceProxyModule {}
